// Imports ------------------------------------------------------------------->
import cx from 'classnames'
import { Component } from '../Component'
import { element } from '../CustomElement'

import { inject } from '../../services/di'
import { AuthenticationService } from '../../services/AuthenticationService'
import { ConfigService } from '../../services/ConfigService'
import { icons } from '../../icons/Icons'
import { i18n } from '../../i18n/I18n'
import { Link } from '../flipp-link/Link'
import { LinkService } from '../../services/LinkService'
import { EventService } from '../../services/EventService'
import { AnalyticsService } from '../../services/AnalyticsService'
import { FormInput } from '../flipp-form-input/FormInput'
import {
    handleFormInputsChange,
    handleLogin,
    handleResendActionRequest,
    handleSubmitRequest,
    setDocumentTitle,
} from './Login.helper'
import { Country, LocationService } from '../../services/LocationService'

@element('flipp-confirm-email-page')
export class ConfirmEmailPage extends Component<any, void> {
    @inject config: ConfigService
    @inject auth: AuthenticationService
    @inject eventService: EventService
    @inject analytics: AnalyticsService
    @inject location: LocationService

    refs: {
        submitForm: HTMLFormElement
        submitBtn: HTMLElement
        spinner: HTMLElement
        codeInput: FormInput
        submitBtnText: HTMLElement
        underButtonText: HTMLElement
        resendCodeBtn: HTMLElement
        resendCodeSpinner: HTMLElement
        responseErrorMsg: HTMLElement
    }

    state = {
        confirmation_code: '',
    }

    email = ''

    header = ''

    onCreate() {
        this.header = this.isResend()
            ? i18n('confirm_email_resend_header')
            : i18n('confirm_email_header')
        setDocumentTitle(this.header)
    }

    onAttach() {
        this.state.confirmation_code = ''
        const urlParams = new URLSearchParams(window.location.search)
        this.email = decodeURIComponent(urlParams.get('email'))
        if (this.email) {
            this.refs.underButtonText.classList.remove('hide')
        }
    }

    render() {
        const isFrench = this.location.locale === 'fr-ca'
        return (
            <main>
                <div class="top-bar">
                    <Link to="listing" class="flipp-logo" title="Flipp">
                        {icons.flippLogoWhite}
                    </Link>
                </div>
                <div class="one-column-content">
                    <div class="one-column-picture">
                        <img
                            src={`https://f.wishabi.net/creative/Distribution/images/verify-email.svg`}
                            alt=""
                        />
                    </div>
                    <div class="header">{this.header}</div>
                    <div class="one-column-text">
                        {this.isResend()
                            ? i18n('confirm_email_resend_text')
                            : i18n('confirm_email_text')}
                    </div>
                    <div class="one-column-form">
                        <form name="submitForm" ref="submitForm">
                            <FormInput
                                ref="codeInput"
                                name={'confirmation_code'}
                                handleChange={this.handleChange}
                                type={'text'}
                                placeholder={i18n('confirm_email_code')}
                            />
                            <div
                                ref="underButtonText"
                                class="one-column-text under-button-text hide"
                            >
                                <div class={cx({ confirm_email_fr: isFrench })}>
                                    {i18n('confirm_email_under_button_text')}
                                </div>
                                <div
                                    class={cx('under-button-action', 'resend', {
                                        fr: isFrench,
                                    })}
                                >
                                    <span
                                        ref="resendCodeBtn"
                                        onClick={this.handleResendAction}
                                    >
                                        {i18n(
                                            'confirm_email_under_button_action'
                                        )}
                                    </span>
                                    <span
                                        ref="resendCodeSpinner"
                                        class="spinner hide"
                                    ></span>
                                </div>
                            </div>
                            <div class="button-container">
                                <button
                                    ref="submitBtn"
                                    class="flipp-button"
                                    onClick={this.handleSubmit}
                                >
                                    <div
                                        ref="submitBtnText"
                                        class="submit-button-text"
                                    >
                                        {i18n('confirm_email_button_text')}
                                    </div>
                                    <div
                                        ref="spinner"
                                        class="spinner hide"
                                    ></div>
                                </button>
                                <p ref="responseErrorMsg" class="error-msg"></p>
                            </div>
                        </form>
                        <div
                            class="maybe-later"
                            onClick={this.handleMaybeLater}
                        >
                            {i18n('maybe_later')}
                        </div>
                    </div>
                </div>
            </main>
        )
    }

    private confirmEmail = async () => {
        await this.auth.finishRegistration({
            confirmation_code: this.state.confirmation_code,
            email: this.email,
        })
        const redirectUri =
            this.location.country === Country.CANADA ? 'opt_in' : 'weekly_ads'
        handleLogin(this.auth.user.token.user_id, this, redirectUri)
    }

    private isResend = () => {
        const urlParams = new URLSearchParams(window.location.search)
        return Boolean(urlParams.get('resend'))
    }

    private handleChange = (e: any) => {
        this.state = handleFormInputsChange(this.state, this.refs, e)
    }

    private handleSubmit = async (e: any) => {
        e.preventDefault()
        this.refs.responseErrorMsg.textContent = ''
        if (this.state.confirmation_code.length === 0) {
            this.refs.codeInput.errorMessage = i18n(
                'enter_confirmation_code_error'
            )
        } else if (this.email) {
            await handleSubmitRequest(this.refs, this.confirmEmail)
        }
    }

    private handleResendAction = async (e: any) => {
        try {
            await handleResendActionRequest(e, this.refs, this.email)
        } catch (e) {
            console.log(e)
        }
    }

    private handleMaybeLater = (e: any) => {
        e.preventDefault()
        const linkService = LinkService.getInstance()
        linkService.execute('weekly_ads', this)
    }
}
